var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('div',{staticClass:"mt-3"},[_c('b-pagination',{staticClass:"pagination-center",attrs:{"pills:total-rows":"rows","size":"lg"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }